export default "__VITE_ASSET__b21620c4__"